import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../../actions/api";
import isEmpty from "../../validations/is-empty";

// import sections
import HeroSection from "./detailsections/HeroSection";
import DetailSection from "./detailsections/DetailSection";
import LoadingJobsSection from "./sections/LoadingJobsSection";

const CareerDetail = () => {
  const { slug } = useParams();

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState({});

  useEffect(() => {
    const params = {
      slug,
    };

    setLoading(true);

    apiClient
      .post("/candidates/get-job-by-slug", params)
      .then(async (res) => {
        if (isEmpty(res.data?.result)) {
          setResult({});
        } else {
          setResult(res.data?.result);
        }

        setLoading(false);
      })
      .catch((err) => {
        if (!isEmpty(err?.response?.data?.errors)) {
          err.response.data.errors.forEach((item) => {
            console.log(item.msg);
          });
        }
        setLoading(false);
      });
  }, [slug]);

  return (
    <div>
      {loading ? (
        <LoadingJobsSection content="Loading role" />
      ) : (
        <>
          <HeroSection job={result} />
          <DetailSection job={result} />
        </>
      )}
    </div>
  );
};

export default CareerDetail;
